import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
function MarketWisdomConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div data-section-id="51777" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} className="flex flex-col gap-4" data-index={i}>
            <div className="bg-muted h-48 w-full animate-pulse rounded-xl" />
            <div className="bg-muted h-6 w-24 animate-pulse rounded-md" />
            <div className="bg-muted h-8 w-3/4 animate-pulse rounded-md" />
            <div className="bg-muted h-4 w-full animate-pulse rounded-md" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-muted-foreground py-12 text-center">
        <p className="mb-4">Unable to load market insights at this time.</p>
        <Button onClick={refetch} variant="link" className="text-primary underline hover:no-underline">
          Try again
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-muted-foreground py-12 text-center">
        <p>No articles found.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const category = post.categories?.[0]?.name || "Expert Insight";
      const image = post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608256/img/market_wisdom_placeholder.png";
      return <Card key={post.id} className="group border border-border bg-card shadow-sm transition-all duration-300 hover:shadow-xl hover:border-primary/10 rounded-xl overflow-hidden" data-index={i}>
            <CardHeader className="p-0">
              <div className="relative overflow-hidden">
                <Link to={post.link || "#"} className="block aspect-[3/2] w-full overflow-hidden bg-muted">
                  <img src={image} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                </Link>
              </div>
            </CardHeader>
            
            <CardContent className="flex flex-col gap-3 p-6">
              <div className="flex items-center gap-3">
                <Badge variant="secondary" className="rounded-md bg-accent px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest text-accent-foreground">
                  {category}
                </Badge>
                <span className="text-xs font-medium text-muted-foreground/80">
                  {post.date ? new Date(post.date).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              }) : ''}
                </span>
              </div>
              
              <h3 className="font-sans text-2xl font-bold leading-tight text-primary group-hover:text-secondary transition-colors">
                <Link to={post.link || "#"}>
                  {post.title}
                </Link>
              </h3>
              
              <div className="text-foreground/80 line-clamp-2 text-base leading-relaxed font-sans" dangerouslySetInnerHTML={{
            __html: post.excerpt || ""
          }} />
            </CardContent>

            <CardFooter className="mt-0 p-6 pt-0">
              <Link to={post.link || "#"} className="group/link inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-primary transition-colors hover:text-secondary">
                Read Article
                <ArrowRight className="h-4 w-4 text-secondary transition-transform duration-300 group-hover/link:translate-x-1" />
              </Link>
            </CardFooter>
          </Card>;
    })}
    </div>;
}
export default function MarketWisdom() {
  const wp_query_params = {
    per_page: 3,
    ignore_sticky: true,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="latest-articles" className="bg-background text-foreground ![padding:0px_0px_15px_0px]">
      
    </section>;
}